<template>
  <div class="row q-col-gutter-md" data-test="indicadores">
    <div v-for="card in cards" :key="card.chave" class="col-12 col-sm-6 col-md-4 col-lg-2">
      <q-card :data-test="`indicador-${card.chave}`" class="full-height">
        <q-card-section>
          <div class="row items-center no-wrap">
            <div class="col">
              <div class="text-grey-9" style="font-size: 16px">{{ card.titulo }}</div>
              <div class="text-bold text-grey-9" style="font-size: 22px">{{ card.valor }}</div>
              <div class="text-caption text-grey-7">{{ card.detalhe }}</div>
            </div>
            <div class="col-auto">
              <q-icon :name="card.icone" :color="card.cor" size="28px" />
            </div>
          </div>
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>

<script>
import { formatPercentual } from "@/utils/venda-online-painel";

const SEM_DADO = "—";

const plural = (total, singular, pluralTexto) => `${total} ${total === 1 ? singular : pluralTexto}`;

export default {
  name: "vendas-online-indicadores",
  props: {
    indicadores: { type: Object, default: null }
  },
  computed: {
    cards() {
      const dados = this.indicadores;
      if (!dados) {
        return [
          { chave: "gerado", titulo: "Total gerado", icone: "receipt_long", cor: "primary" },
          { chave: "liquidado", titulo: "Liquidado", icone: "check_circle", cor: "positive" },
          { chave: "aberto", titulo: "Em aberto", icone: "link", cor: "blue-7" },
          { chave: "encerrado", titulo: "Expirado / cancelado", icone: "block", cor: "grey-7" },
          { chave: "conversao", titulo: "Conversão", icone: "trending_up", cor: "teal" },
          { chave: "conflito", titulo: "Em conflito", icone: "report", cor: "red-7" }
        ].map((card) => ({ ...card, valor: SEM_DADO, detalhe: "" }));
      }

      const encerradas = { qtd: dados.expirado.qtd + dados.cancelado.qtd, valor: dados.expirado.valor + dados.cancelado.valor };

      return [
        { chave: "gerado", titulo: "Total gerado", icone: "receipt_long", cor: "primary", ...this.moeda(dados.gerado) },
        { chave: "liquidado", titulo: "Liquidado", icone: "check_circle", cor: "positive", ...this.moeda(dados.liquidado) },
        { chave: "aberto", titulo: "Em aberto", icone: "link", cor: "blue-7", ...this.moeda(dados.aberto) },
        {
          chave: "encerrado",
          titulo: "Expirado / cancelado",
          icone: "block",
          cor: "grey-7",
          ...this.moeda(encerradas),
          detalhe: `${plural(encerradas.qtd, "venda", "vendas")} (${plural(dados.expirado.qtd, "expirada", "expiradas")} · ${plural(dados.cancelado.qtd, "cancelada", "canceladas")})`
        },
        { chave: "conversao", titulo: "Conversão", icone: "trending_up", cor: "teal", valor: formatPercentual(dados.conversao), detalhe: "liquidadas sobre geradas" },
        { chave: "conflito", titulo: "Em conflito", icone: "report", cor: "red-7", ...this.moeda(dados.conflito) }
      ];
    }
  },
  methods: {
    moeda({ qtd, valor }) {
      return { valor: `R$ ${this.$currency(valor)}`, detalhe: plural(qtd, "venda", "vendas") };
    }
  }
};
</script>
